import * as types from "../types/pickerPakerPage.types";
import { 
  getList,
  getDetail,
  patchEdit,
  patchBlock,
  patchSuspended,
  patchApprove,
  patchAssignZone,
  patchEditPasscode,
} from '../../services/pickerpacker.service';
import { validationErrors } from "../../utils/Helpers";

export const listAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      await getList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        dispatch({
          type: types.SET_LIST_DATA,
          payload: res.data.data,
        });
        dispatch({
          type: types.SET_LIST_PAGINATION,
          payload: res.data.pagination,
        });
      })
    } catch (e) {
      validationErrors(e)
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};

export const filterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_LIST_FILTER,
      payload: data,
    });
  };
};


export const detailAction = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      await getDetail(getState().authReducer.token, getState().authReducer.user.id, id).then((res) => {
        dispatch({
          type: types.SET_DETAIL_DATA,
          payload: res.data.data,
        });
      })
    } catch (e) {
      validationErrors(e)
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};

export const patchAction  = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      return await patchEdit(getState().authReducer.token, getState().authReducer.user.id, id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};

export const patchPasscodeAction  = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      return await patchEditPasscode(getState().authReducer.token, getState().authReducer.user.id, id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};

export const blockAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      return await patchBlock(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};

export const suspendedAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      return await patchSuspended(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};

export const approveAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      return await patchApprove(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};


export const assignZoneAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      return await patchAssignZone(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};








